import { BaseStorage } from '../base-storage';
import { LocalStorageKey, LocalStorageValue } from './index';

export const LocalStorageChangeEventName = 'local-storage-change';
const changeEvent = new Event(LocalStorageChangeEventName);

export class LocalStorageService extends BaseStorage {
  public constructor(document: Document) {
    if (document?.defaultView === null) {
      throw new Error('Local storage initialization error!');
    }

    super(document.defaultView.localStorage);
  }

  public getItem<T extends LocalStorageValue>(key: LocalStorageKey): T {
    return this.get(key) as T;
  }

  public setItem(key: LocalStorageKey, value: LocalStorageValue): boolean {
    const item = this.set(key, value);
    window.dispatchEvent(changeEvent);
    return item;
  }

  public removeItem(key: LocalStorageKey): boolean {
    const item = this.remove(key);
    window.dispatchEvent(changeEvent);
    return item;
  }
}
